import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ngbLargeModalOptions } from 'src/app/Configs/modal-config';
import { CommonService } from 'src/app/Service/Common.service';
declare var $: any;
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit {
  @ViewChild('SendEmail', { static: false }) SendEmailTemplate: TemplateRef<any>;
  modalRef: BsModalRef;
  formData: FormData = new FormData();
  Email: any = {};
  Editor = ClassicEditor;
  TechnicianPDF: any = {};
  constructor(
    private modalService: BsModalService,
    private commServ: CommonService,
    private toastr: ToastrManager
  ) { }

  ngOnInit() {
  }

  OpenTechnicianEmail(TechnicianIds, Type, IsTechnician) {
    this.TechnicianPDF = {};
    this.TechnicianPDF.TechnicianIds = TechnicianIds;
    this.TechnicianPDF.Type = Type;
    this.commServ.PostWithAuth('Technician', 'DownloadCVs', this.TechnicianPDF).subscribe(response => {
      this.Email.Attachments = response;
      if (IsTechnician) {
        this.Email.Tos = localStorage.getItem('email');
      }
      this.Email.Message = null;
      this.modalRef = this.modalService.show(this.SendEmailTemplate, ngbLargeModalOptions);
    }, err => {
      this.toastr.errorToastr(err, 'Error');
    });
  }

  OpenValidationEmail(TechnicianId) {
    this.commServ.GetWithAuth('Technician', 'SendValidation?TechnicianId=' + TechnicianId).subscribe(response => {
      this.Email = response;
      this.Email.Attachments = [];
      this.modalRef = this.modalService.show(this.SendEmailTemplate, ngbLargeModalOptions);
    }, err => {
      this.toastr.errorToastr(err, 'Error');
    });
  }

  OpenLookupDeclineEmail(LookupId) {
    this.commServ.GetWithAuth('Lookup', 'SendDeclineLookupEmail?LookupId=' + LookupId).subscribe(response => {
      this.Email = response;
      this.Email.Attachments = [];
      this.modalRef = this.modalService.show(this.SendEmailTemplate, ngbLargeModalOptions);
    }, err => {
      this.toastr.errorToastr(err, 'Error');
    });
  }

  SendTechnicianEmail() {
    let message = '';
    let Presult = false;
    if (!this.Email.Tos && !this.Email.ToBCCs && !this.Email.ToCCs) {
      message += 'Tos or ToCCs or ToBCCs,';
      Presult = true;
    }
    if (!this.Email.Subject) {
      message += 'Subject,';
      Presult = true;
    }
    if (!this.Email.Message) {
      message += 'Message,';
      Presult = true;
    }
    if (Presult) {
      this.toastr.warningToastr('Please fill ' + message.substr(0, message.length - 1), 'Warning');
      return false;
    }
    this.commServ.PostWithAuth('Lookup', 'SendEmail', this.Email).subscribe(response => {
      this.Email = {};
      this.modalRef.hide();
      this.toastr.successToastr('Send Email success..', 'success');
    }, err => {
      this.toastr.errorToastr(err, 'Error');
    });
  }

  CloseDialog() {
    this.modalRef.hide();
  }

  AddFile(event) {
    const files = event.target.files;
    const file = files[0];
    this.formData.append('File0', file, file.name);
    this.commServ.PostWithAuth('Upload', 'CommonAttachmentUpload', this.formData).subscribe(response => {
      this.formData = new FormData();
      this.Email.Attachments.push(response);
      this.toastr.successToastr('Attachment added..', 'success');
    }, err => {
      this.toastr.errorToastr(err, 'Error');
    });
    $('.DrivingUpload').val('');
  }

  RemoveAttachment(Index) {
    this.Email.Attachments.splice(Index, 1);
  }

  OpenContactEmail() {
    this.Email = {};
    this.Email.Tos = 'MD@worqforc.com';
    this.Email.ToCCs = localStorage.getItem('email');
    this.Email.Subject = 'Worqforc Enquiry';
    this.Email.Attachments = [];
    this.Email.Message = null;
    this.modalRef = this.modalService.show(this.SendEmailTemplate, ngbLargeModalOptions);
  }

}
